module.exports = __webpack_public_path__ + "img/ic_16_close.f64bf39d.svg";